import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";

const CommitteApprovalManagementApi = createApi({
    reducerPath: 'CommitteApprovalManagementApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getAllCommitteApprovalList: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/GetAllCommitteApprovalList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteCommitteApprovalMemberById: builder.mutation({
            query: (details) => ({
                url: `/GMPCourseProvider/DeleteCommitteApprovalMemberById/?id=${details.id}`,
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditCommitteApproval: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/AddEditCommitteApproval',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCommitteeApprovalByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/GMPCourseProvider/GetCommitteeApprovalByMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        committeeApprovalAssignmentList: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/CommitteeApprovalAssignmentList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        committeeApprovalList: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/CommitteeBatchApprovalList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        assignCourseOrCpdToCommitteeApproval: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/AssignCourseOrCpdToCommitteeApproval',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getComitteBatchApprovalByBatchNumber: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/GMPCourseProvider/GetComitteBatchApprovalByBatchNumber?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCommitteBatchApprovalCourseListByBatchNo: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/GetCommitteBatchApprovalCourseListByBatchNo',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        committeeCPDApprovalAssignmentList: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/CommitteeCPDApprovalAssignmentList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
export const {
    useGetAllCommitteApprovalListMutation,
    useDeleteCommitteApprovalMemberByIdMutation,
    useAddEditCommitteApprovalMutation,
    useLazyGetCommitteeApprovalByMemberIdQuery,
    useCommitteeApprovalAssignmentListMutation,
    useCommitteeApprovalListMutation,
    useAssignCourseOrCpdToCommitteeApprovalMutation,
    useLazyGetComitteBatchApprovalByBatchNumberQuery,
    useGetCommitteBatchApprovalCourseListByBatchNoMutation,
    useCommitteeCPDApprovalAssignmentListMutation
} = CommitteApprovalManagementApi;

export default CommitteApprovalManagementApi;